import React, {useCallback, useEffect, useState, useMemo} from 'react'
import {Button, Card} from "react-bootstrap";
import ReportMilestoneForm from "../../Partials/ReportMilestoneForm";
import './EditFactForm.less'
import useAPI from "../../../../hooks/useAPI";
import {useHistory, useParams} from "react-router-dom";
import useToast from "../../../../hooks/useToast";
import {years} from "../../../../helpers";
import useUserContext from '../../../../hooks/useUserContext';
import { getActionsModel } from '../../../../services/roles/projMilestoneRoleStatus';
import ModalSendForRevision from '../../../common/ModalSendForRevision';
import ApproveMilestoneModal from './ApproveMilestoneModal';
import StatusBadge from '../../../common/StatusBadge';
import { MILESTONE_STATUSES_RU } from '../../../../helpers/report';

export default function EditFactForm(){
    const [milestone, setMilestone] = useState({});
    const [initialMilestoneState, setInitialMilestoneState] = useState([])
    const [trls, setTrls] = useState([]);
    const [startValidation, setStartValidation] = useState(false);
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [newFiles, setNewFiles] = useState([]);
    const [image, setImage] = useState(null)
    const [isModalReject, setIsModalReject] = useState({
        show: false,
        value: null,
    });
    const [isModalApprove, setIsModalApprove] = useState({
        show: false,
        value: null,
    });

    const {stratId, projId, policyId, portfolioId, milestoneId} = useParams()
    const api = useAPI();
    const addToast = useToast();
    const history = useHistory();
    const userCtx = useUserContext();

    const can = useMemo(() => getActionsModel(milestone.status, userCtx, stratId, portfolioId, projId, policyId), [milestone.status, userCtx]);

    useEffect(async () => {
        const milestone = await api.get(`/projs/${projId}/milestones/${milestoneId}`)
        const trls = await api.get('/mng/trls')
        setMilestone(milestone)
        setInitialMilestoneState(milestone)
        setTrls(trls)
    }, [])

    const handleSave = async () => {
        setLoading(true)
        setValidated(true)
        setStartValidation((prevState) => !prevState)
        if (milestone.monthFact && milestone.yearFact && milestone.result && milestone.result.replaceAll(' ', '').length <= 1500){
            const keys = ['monthFact', 'yearFact', 'result', 'trlFactId', 'publishInMedia', 'newsHeaderDraft']
            const fact = {}
            keys.forEach((key) => fact[key] = milestone[key])
            const isSuccess = {
                fact: true,
                image: true,
                files: true
            }
            const factResp = await api.post(`/projs/${projId}/milestones/${milestoneId}/fact`, fact)
            if(!factResp.projMilestoneOriginId) isSuccess.fact = false;
            const imageResp = image && !milestone.imageFileId && isSuccess.fact ? await api.postFileFixed(`/projs/${projId}/milestones/${milestoneId}/image`, {}, image, 'image') : null
            if(imageResp?.id) setMilestone(prevState => ({...prevState, imageFileId: imageResp?.id}))
            if(imageResp?.error) isSuccess.image = false
            const filesResp = newFiles.length > 0 && isSuccess.fact && isSuccess.image ? await api.postFiles(`/projs/${projId}/milestones/${milestoneId}/files`, newFiles) : null
            if(filesResp && !filesResp.ok) isSuccess.files = false
            else if(filesResp){
                const files = await filesResp.json()
                setNewFiles([])
                setMilestone(prevState => ({...prevState, files: [...(prevState.files || []), ...files]}))
            }
            if(Object.values(isSuccess).includes(false)){
                const fileError = filesResp ? await filesResp.json() : null
                if(fileError?.error?.message){
                    addToast.error(fileError.error.message)
                }
                setLoading(false)
                return false
            }
            else{
                setInitialMilestoneState({...milestone})
                addToast.success('Веха успешно сохранена')
                setLoading(false)
                return true
            }
        }
        setLoading(false)
        return false
    }

    const requests = {
        send: async (ent) => {
        const result = await api.post(`/projs/${ent.projId}/milestones/${ent.id}/send`);
        if (result && !result.error) {
            setMilestone(prevState => ({...prevState, status: result.status, id: result.id}))
            addToast.success('Веха отправлена на согласование');
            return true;
        } else return false;
        },
        reject: async (ent, comment) => {
          const result = await api.post(`/projs/${ent.projId}/milestones/${ent.id}/reject`, { comment });
          if (result && !result.error) {
            setMilestone(prevState => ({...prevState, status: result.status, id: result.id}))
            addToast.success('Веха не согласована');
            return true;
          } else return false;
        },

        approve: async (ent, news, image) => {
          const result = await api.postFileFixed(`/projs/${ent.projId}/milestones/${ent.id}/approve`, news, image);
          if (result && !result.error) {
            setMilestone(prevState => ({...prevState, status: result.status, id: result.id}))
            addToast.success('Веха согласована');
            addToast.success('Веха опубликована в разделе «Новости»');
          } else return false;
        }
    }
    
    const handleReject = async (comment) => {
        await requests.reject(isModalReject.value, comment);
        setIsModalReject({ show: false, value: null });
    };
    const handleApprove = async() => {
        const successfulSave = await handleSave()
        if(successfulSave){
            const ent = isModalApprove.value;
            history.push(`/news/edit/new?milestone=${ent.id}&projId=${ent.projId}&portfId=${portfolioId}&policyId=${policyId}&strategyId=${stratId}`);
        }
    };
    const handleApproveWithoutNews = async () => {
        const successfulSave = await handleSave()
        if(successfulSave){
            await requests.approve(isModalApprove.value, {}, null);
            setIsModalApprove({ show: false, value: null });
        }
    };

    return (
        <div className='editFact'>
            <h2 style={styledTitle}>Внести/Изменить факт по вехе</h2>
            <Card className='mt-5'>
                <Card.Header className='px-4 py-3 d-flex justify-content-between'>
                    <Card.Title className='editFact-subtitle m-0'>Вехи проекта</Card.Title>
                    <StatusBadge type='milestones' status={milestone.status || MILESTONE_STATUSES_RU.new.key}/>
                </Card.Header>
                <Card.Body className='px-4 py-4'>
                    <ReportMilestoneForm milestone={milestone}
                                         setMilestone={setMilestone}
                                         trls={trls}
                                         startValidation={startValidation}
                                         validated={validated}
                                         setFiles={setNewFiles}
                                         newFiles={newFiles}
                                         image={image}
                                         setImage={setImage}
                    />
                </Card.Body>
            </Card>
            <Card className='mt-4'>
                <Card.Body className='px-4 py-4 d-flex flex-row gap-2'>
                    <Button variant="outline-secondary" onClick={() => history.goBack()}>Отменить</Button>
                    <Button disabled={loading} onClick={handleSave}>Сохранить</Button>
                    {can.Send && initialMilestoneState.publishInMedia && initialMilestoneState.monthFact && initialMilestoneState.yearFact &&
                        <Button variant='outline-warning' onClick={() => requests.send(milestone)}>Отправить на согласование</Button>}
                    {can.Approve && <Button variant='outline-success' onClick={() => setIsModalApprove({ show: true, value: milestone })}>Согласовать</Button>}
                    {can.Approve && <Button variant='outline-danger' onClick={() => setIsModalReject({ show: true, value: milestone })}>Не согласовать</Button>}
                </Card.Body>
            </Card>
            <ModalSendForRevision
                show={isModalReject.show}
                onClose={() => setIsModalReject({ show: false, value: null })}
                onSubmit={(comment) => handleReject(comment)}
                headerText="Не согласовать"
                label="Комментарий"
            />
            <ApproveMilestoneModal
                show={isModalApprove.show}
                onClose={() => setIsModalApprove({ show: false, value: null })}
                onReject={() => handleApproveWithoutNews()}
                onConfirm={() => handleApprove()}
            />
        </div>
    )
}

const styledTitle = {
    fontSize: 24,
    fontWeight: 600,
    textAlign: 'left'
}